import getUrl from "@/Helpers/BaseUrl";
import { Contact } from "@/types/Api/contact";
import axios from "axios";
import _ from "lodash";
export async function saveContact(contact) {
    const response = await axios.put(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Contact/${contact.Id}`), contact);
    return new Contact(response.data);
}
export async function createContact(contact) {
    const response = await axios.post(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Contact`), contact);
    return new Contact(response.data);
}
export async function searchContacts(q, page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Contact/Search?q=${q}&startPage=${page}&Count=${pageSize}`));
    return _.map(response.data, app => new Contact(app));
}
export async function getContactDetails(id) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Contact/${id}`));
    return new Contact(response.data);
}
export async function getAllPositions(page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Position?startPage=${page}&Count=${pageSize}`));
    return response.data;
}
